module.exports = __webpack_public_path__ + "static/media/pexels-pineaple.da4889d3.jpeg";